import { randomTitle, RandomGenerator } from '..';
var MacroBuilder = /** @class */ (function () {
    function MacroBuilder() {
        this.macro = {
            id: 'b0bb0b0b-b0b0-b0b0-b0b0-b0bb0bb0bb0b',
            name: 'My Test Macro',
            creationDate: Date.now() - 3600000,
            lastUpdateDate: Date.now(),
            actions: [],
            disabled: true
        };
    }
    MacroBuilder.prototype.withId = function (id) {
        this.macro.id = id;
        return this;
    };
    MacroBuilder.prototype.withName = function (name) {
        this.macro.name = name;
        return this;
    };
    MacroBuilder.prototype.withDescription = function (description) {
        this.macro.description = description;
        return this;
    };
    MacroBuilder.prototype.withCreationDate = function (creationDate) {
        this.macro.creationDate = creationDate;
        return this;
    };
    MacroBuilder.prototype.withLastUpdateDate = function (lastUpdateDate) {
        this.macro.lastUpdateDate = lastUpdateDate;
        return this;
    };
    MacroBuilder.prototype.withDisabled = function (disabled) {
        this.macro.disabled = disabled;
        return this;
    };
    MacroBuilder.prototype.withActions = function (actions) {
        this.macro.actions = actions;
        return this;
    };
    MacroBuilder.prototype.withMacroRestrictions = function (macroRestrictions) {
        this.macro.macroRestrictions = macroRestrictions;
        return this;
    };
    MacroBuilder.prototype.build = function () {
        return this.macro;
    };
    MacroBuilder.prototype.generateRandomList = function (num) {
        return randomTitle(num)
            .map(function (name) { return new MacroBuilder()
            .withName(name)
            .withId(RandomGenerator.randomId())
            .build(); });
    };
    return MacroBuilder;
}());
export { MacroBuilder };
//# sourceMappingURL=macro.builder.js.map